@import '~style-sheet-helpers/core.less';

.printing-selection {
  width: calc(100% - 50px);
  margin-bottom: 10px;
  button {
    width: 100%;
  }
}
